import React from "react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionHeading } from "@/components/sections/SectionHeading";
import { ESG } from "@/data/content";

export const ShreeSeva = () => {
  return (
    <section id="esg-values" data-testid="esg-values" className="relative overflow-hidden bg-gradient-to-b from-ivory-light to-ivory py-24 sm:py-32">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-gold-rose/20 blur-3xl" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-[1fr_1.1fr]">
          {/* stat */}
          <Reveal>
            <div className="relative rounded-[2.5rem] border border-amber-200/50 bg-gradient-to-br from-white/80 to-gold-rose/10 p-10 backdrop-blur-xl">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">ShreeSeva · Impact</p>
              <p className="mt-6 font-serif text-6xl font-light leading-none text-gold-gradient sm:text-7xl">{ESG.stat}</p>
              <p className="mt-5 max-w-sm text-lg leading-relaxed text-charcoal">{ESG.statLabel}</p>
            </div>
          </Reveal>

          <div>
            <SectionHeading
              overline="Values"
              title="Wealth with a conscience"
              accentWord="conscience"
              subtitle="Shreedhan is built around the women who anchor Indian families — and around a planet we'd like to leave a little greener."
            />
            <StaggerGroup className="mt-10 space-y-5" stagger={0.1}>
              {ESG.points.map((p) => (
                <StaggerItem key={p.title}>
                  <div className="flex items-start gap-4 rounded-2xl border border-amber-200/40 bg-white/60 p-5 backdrop-blur-sm">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold/12">
                      <p.icon className="h-5 w-5 text-gold" strokeWidth={1.9} />
                    </span>
                    <div>
                      <h3 className="font-serif text-lg text-charcoal">{p.title}</h3>
                      <p className="mt-1 text-sm leading-relaxed text-charcoal-soft">{p.body}</p>
                    </div>
                  </div>
                </StaggerItem>
              ))}
            </StaggerGroup>
          </div>
        </div>
      </div>
    </section>
  );
};
